import toastr from 'toastr';
import _ from 'lodash';

/**
 * Shows an informational toast. Renders it bottom-left without a progress bar and with duplicate suppression on.
 *
 * @param message - Text shown in the toast.
 * @param title - Optional heading shown above the message.
 * @returns Nothing.
 */
export const toastrInfo = (message: string, title?: string) => {
  toastr.info(message, title, {
    progressBar: false,
    positionClass: 'toast-bottom-left',
    preventDuplicates: true,
  });
};

/**
 * Shows a success toast. Renders it bottom-left without a progress bar and with duplicate suppression on.
 *
 * @param message - Text shown in the toast.
 * @param title - Optional heading shown above the message.
 * @returns Nothing.
 */
export const toastrSuccess = (message: string, title?: string) => {
  toastr.success(message, title, {
    progressBar: false,
    positionClass: 'toast-bottom-left',
    preventDuplicates: true,
  });
};

/**
 * Shows an error toast unless the message is one of the known noise cases. Suppresses everything while the session is expired, and skips fetch failures, aborted requests, network errors, invalid access tokens and 503 responses before rendering a bottom-left toast with duplicate suppression on.
 *
 * @param message - Error text shown in the toast.
 * @param title - Optional heading shown above the message.
 * @returns Nothing.
 */
export const toastrError = (message: string, title?: string) => {
  if (window.isSessionExpired) {
    return;
  }
  console.log('[Toastr]-error', message);
  if (_.includes(message, 'Failed to fetch')) {
    return;
  }
  if (message === 'signal is aborted without reason') {
    return;
  }
  // Because _.includes('...400 max char','400') === _.includes('400 bad request','400')
  if (
    !_.includes(message, 'The user aborted a request') &&
    !_.includes(message, 'The operation was aborted') &&
    !_.includes(message, 'Network error') &&
    !_.includes(message, 'Invalid access token') &&
    !_.includes(message, 'Received status code 503')
  ) {
    toastr.error(message, title, {
      progressBar: false,
      positionClass: 'toast-bottom-left',
      preventDuplicates: true,
    });
  }
};
